import Vue from 'vue';
export const eventBus = new Vue();


// WEBPACK FOOTER //
// ./src/components/view/livechat/event-bus.js